import {
    AUTHENTICATING_MS_DYNAMICS_REQUEST, AUTHENTICATING_MS_DYNAMICS_SUCCEDDED, AUTHENTICATING_MS_DYNAMICS_FAILED,
    UPDATING_MS_DYNAMICS_REQUEST, UPDATING_MS_DYNAMICS_SUCCEDDED, UPDATING_MS_DYNAMICS_FAILED, 
    FETCHING_MS_DYNAMICS_INTEGRATION_REQUEST, FETCHING_MS_DYNAMICS_INTEGRATION_SUCCEDDED, FETCHING_MS_DYNAMICS_INTEGRATION_FAILED,
    DEACTIVATING_MS_DYNAMICS_INTEGRATION_REQUEST, DEACTIVATING_MS_DYNAMICS_INTEGRATION_SUCCEDDED, DEACTIVATING_MS_DYNAMICS_INTEGRATION_FAILED
  } from '../actionTypes.jsx';
import { activatingIntegrationSuccedded, fetchingIntegrationSuccedded, deactivatingIntegrationSuccedded  } from '../integrations';
import axios from 'axios';

  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  
  const MS_DYNAMICS_BASE_URL = `${apiUrl}/api/2.0/integrations/ms-dynamics`;
  const MS_DYNAMICS_BASE_URL_V2 = `${apiUrl}/api/2.1/integrations/ms-dynamics`;

  export function validateInstance(instanceUrl){
    return function (dispatch) {
    
    const param = {
    instance: instanceUrl
    }
    return axios({
    method: 'GET',
    url: `${MS_DYNAMICS_BASE_URL}/validate`,
    params: param
    })
    .then(response =>{
        return response.data;
    })
    .catch(error => {
      console.log(error)
    })
    }
    }
  
  export function authenticateAccount(code, instanceUrl){
    return function (dispatch) {
      dispatch(authenticatingAccount());

      const data = {
        code: code,
        instance: instanceUrl
      }
  
      return axios({
        method: 'POST',
        url: MS_DYNAMICS_BASE_URL_V2,
        params: data
      })
      .then((response) => {
        dispatch(authenticatingAccountSuccedded(response.data));
        dispatch(activatingIntegrationSuccedded(response.data));
      })
      .catch(error =>
        dispatch(authenticatingAccountFailed(error.errors))
      )
    }
  }
  
  function authenticatingAccount(){
    return {
      type: AUTHENTICATING_MS_DYNAMICS_REQUEST,
      payload: {}
    }
  }
  
  function authenticatingAccountSuccedded(json){
    return {
      type: AUTHENTICATING_MS_DYNAMICS_SUCCEDDED,
      payload: json
    }
  }
  
  function authenticatingAccountFailed(error){
    return {
      type: AUTHENTICATING_MS_DYNAMICS_FAILED,
      payload: error
    }
  }


/**
* Update microsoft dynamics configuration
*/
export function updateConfiguration(configuration){
    return function (dispatch) {
      dispatch(updatingConfiguration());
  
      return axios({
        method: 'PUT',
        url: MS_DYNAMICS_BASE_URL_V2,
        data: configuration
      })
      .then((response) => {
        dispatch(updatingConfigurationSuccedded(response.data));
        dispatch(activatingIntegrationSuccedded(response.data));
      })
      .catch(error => {
        dispatch(updatingConfigurationFailed(error.errors))
      })
    }
  }
  
  function updatingConfiguration(){
    return {
      type: UPDATING_MS_DYNAMICS_REQUEST,
      payload: {}
    }
  }
  
  function updatingConfigurationSuccedded(json){
    return {
      type: UPDATING_MS_DYNAMICS_SUCCEDDED,
      payload: json
    }
  }
  
  function updatingConfigurationFailed(error){
    return {
      type: UPDATING_MS_DYNAMICS_FAILED,
      payload: error
    }
  }


/**
* Fetch msdynamics integration
*/
export function fetchMsDynamicsIntegration() {
  return function (dispatch) {
    dispatch(fetchingMsDynamicsIntegration());

    return axios({
      method: 'GET',
      url: MS_DYNAMICS_BASE_URL_V2
    })
    .then((response) => {
      dispatch(fetchingMsDynamicsIntegrationSuccedded(response.data));
      dispatch(fetchingIntegrationSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error =>
      dispatch(fetchingMsDynamicsIntegrationFailed(error.errors))
    )
  }
}

function fetchingMsDynamicsIntegration(){
  return {
    type: FETCHING_MS_DYNAMICS_INTEGRATION_REQUEST,
    payload: {}
  }
}

function fetchingMsDynamicsIntegrationSuccedded(json){
  return {
    type: FETCHING_MS_DYNAMICS_INTEGRATION_SUCCEDDED,
    payload: json
  }
}

function fetchingMsDynamicsIntegrationFailed(error){
  return {
    type: FETCHING_MS_DYNAMICS_INTEGRATION_FAILED,
    payload: error
  }
}

export function deactivateMsDynamicsIntegration(integrationType){
  return function (dispatch) {
    dispatch(deactivatingMsDynamicsIntegration());
    
    return axios({
      method: 'DELETE',
      url: MS_DYNAMICS_BASE_URL_V2,
      params: {type: 'user'}
    })

    .then((response) => {
      dispatch(deactivatingMsDynamicsIntegrationSuccedded({type: integrationType,data:response.data}));
      dispatch(deactivatingIntegrationSuccedded({type: integrationType,data:response.data}));
    })
    .catch(error =>
      dispatch(deactivatingMsDynamicsIntegrationFailed(error.errors))
    )
  }
}

function deactivatingMsDynamicsIntegration(){
  return {
    type: DEACTIVATING_MS_DYNAMICS_INTEGRATION_REQUEST,
    payload: {}
  }
}

function deactivatingMsDynamicsIntegrationSuccedded(json){
  return {
    type: DEACTIVATING_MS_DYNAMICS_INTEGRATION_SUCCEDDED,
    payload: json
  }
}

function deactivatingMsDynamicsIntegrationFailed(error){
  return {
    type: DEACTIVATING_MS_DYNAMICS_INTEGRATION_FAILED,
    payload: error
  }
}
export function authenticateSecondaryAccount(id, code, instanceUrl) {
  return function (dispatch) {
    dispatch(authenticatingSecondaryAccount());

    const data = {
      code: code,
      instance: instanceUrl
    }

    return axios({
      method: 'POST',
      url: `${MS_DYNAMICS_BASE_URL_V2}/${id}/override/change_user`,
      headers: {'Content-Type':'application/x-www-form-urlencoded'},
      params: data
    })
    .then((response) => {
      dispatch(authenticatingSecondaryAccountSuccedded(response.data));
      dispatch(activatingIntegrationSuccedded(response.data));
    })
    .catch(error => {
      dispatch(authenticatingSecondaryAccountFailed(error))
    })
  }
}

function authenticatingSecondaryAccount(){
  return {
    type: UPDATING_MS_DYNAMICS_REQUEST,
    payload: {}
  }
}

function authenticatingSecondaryAccountSuccedded(json){
  return {
    type: UPDATING_MS_DYNAMICS_SUCCEDDED,
    payload: json
  }
}

function authenticatingSecondaryAccountFailed(error){
  return {
    type: UPDATING_MS_DYNAMICS_FAILED,
    payload: error
  }
}